module.exports = __webpack_public_path__ + "img/largus.ef01c532.svg";